import React, { Component } from 'react';
import { connect } from 'react-redux'
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { Singleton } from '../../../js/Singleton';
import { INTEGRATION, DRAGGABLE_WINDOWS, ACTION_CALL_ACD } from '../../../constants.js';
import { digits } from '../../../Images/Images';
import { send } from '../../../Images/GenericSVG';
import { dtmfSVG } from '../../../Images/CallSpaceHeaderSVG';
import { validateOnlyNumbers } from '../../../js/helpers/Utils/Validations';
import { removeWindow } from '../../../redux/actions/A_draggable_windows_controller'
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import Keyboard from '../Others/Keyboard.jsx'
import { callAction } from '../../../redux/actions/A_reducer_call_acd';
import DTMF_Click from '../../../audios/DTMF_Click.mp3'


class DTMFWindow extends Component {
  constructor(props) {
    super(props);
    this.sharedData = new SingletonSharedData();
    this.language = new Singleton();
    this.audio = null;
    this.state = {
      toneNumber: "",
      tonesSend: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.messagesIntegrations) {
      if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === INTEGRATION.CALL_ACTION && nextProps.messagesIntegrations.dataMessageIntegration.callAction === INTEGRATION.DTMF) {
        let _this = this;
        _this.pressDTMFTone(nextProps.messagesIntegrations.dataMessageIntegration.digit);
        _this.setState({ toneNumber: this.state.toneNumber + nextProps.messagesIntegrations.dataMessageIntegration.digit });
      }
    }
  }

  componentDidMount() {
    if (this.props.objProps.digit) {
      this.pressDTMFTone(this.props.objProps.digit);
      this.setState({ toneNumber: this.state.toneNumber + this.props.objProps.digit });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.toneNumber !== prevState.toneNumber) {
      if (this.state.toneNumber !== "") {
        const number = this.state.toneNumber[this.state.toneNumber.length - 1];
        this.pressDTMFTone(number);
      }
    }
  }

  pressDTMFTone(tone) {
    this.audio = new Audio(DTMF_Click);
    this.audio.play();
    this.props.callAction(ACTION_CALL_ACD.DTMF, tone);
  }
  sendDTMF(tone) {
    this.props.callAction(ACTION_CALL_ACD.DTMF, tone);
  }
  closeWindow(){
    this.props.oncloseDtmfTonesWindow && this.props.oncloseDtmfTonesWindow();
    this.props.removeWindow(DRAGGABLE_WINDOWS.DTMF_TONES)
  }
  render() {
    const { dtmfOptions } = this.props.objProps;

    return (
      <div className="DTMFWindow" onClick={() => this.props.goTopZ(this.props.id)}>
        {CUSTOM_COMPONENTS["draggableHeader"](dtmfSVG,
          this.language.getText("CallControlGUIDTMFtitle"),
          () => this.closeWindow())}
        <Keyboard
          number={this.state.toneNumber}
          onChangeNumber={(tone) => this.setState({ toneNumber: tone })}//{(tone)=>this.pressDTMFTone(tone)}
          onClean={() => this.setState({ toneNumber: "" })} />
        {dtmfOptions.length > 0 &&
          <div className="extraInfoDTMF">
            <div className="buttonsDTMF">
              {dtmfOptions.map((item) =>
                <p className="buttonDTMF" key={item.DTMF} onClick={() => this.sendDTMF(item.DTMF)}>{item.Tag}</p>)}
            </div>
            <div className="sendContainer">
              <img className="leftDTMF" src={digits} alt="icon"></img>
              <div className="divSeparator"></div>
              <input type="text"
                placeholder={this.language.getText("CallControlGUIDTMFdigitsLbl")} //
                maxLength="20"
                className="sendDTMF"
                value={this.state.tonesSend}
                onChange={event => { this.setState({ tonesSend: event.target.value }) }}
                onKeyPress={validateOnlyNumbers} />
              <div className="sendButton" onClick={() => this.sendDTMF(this.state.tonesSend)}>{send}</div>
            </div>
          </div>
        }
      </div>
    );
  }
};
function mapStateToProps(state) {
  return {
    messagesIntegrations: state.messagesIntegrations
  }
}
function mapDispatchToProps(dispatch) {
  return ({
    removeWindow: (iDdragComponent) => { dispatch(removeWindow(iDdragComponent)); },
    callAction: (actionType, parameters) => { dispatch(callAction(actionType, parameters)); },
  });
}
export default DTMFWindow = connect(
  mapStateToProps,
  mapDispatchToProps
)(DTMFWindow);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/DTMFWindow.jsx